import { render, staticRenderFns } from "./standard_substance_list.vue?vue&type=template&id=7914da5f&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./standard_substance_list.vue?vue&type=script&lang=js"
export * from "./standard_substance_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports